import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar"

interface TestimonialsSection1Props {
  quote?: string
  authorName?: string
  authorRole?: string
  avatarSrc?: string
  result?: string
}

export default function TestimonialsSection1({
  quote = "До FeedbackIQ я тратил каждый понедельник на чтение обращений. После внедрения — полная картина за 30 минут. Мы поймали критический баг через 2 часа после первого обращения.",
  authorName = "Михаил К.",
  authorRole = "Head of Product, CRM-платформа",
  avatarSrc = "",
  result = "Время обнаружения проблем: с 5 дней до 2 часов",
}: TestimonialsSection1Props) {
  return (
    <section
      className="dark:bg-background container-padding-x section-padding-y flex flex-col items-center border-b bg-blue-950"
      aria-labelledby="testimonial-title"
    >
      <div className="flex max-w-2xl flex-col items-center gap-8">
        <blockquote id="testimonial-title" className="text-center text-xl font-medium text-white md:text-2xl">
          &quot;{quote}&quot;
        </blockquote>

        <div className="flex flex-col items-center gap-4">
          <Avatar className="h-12 w-12 rounded-xl ring-2 ring-white md:h-14 md:w-14">
            <AvatarImage src={avatarSrc || "/placeholder.svg"} alt={authorName} />
            <AvatarFallback className="bg-primary text-primary-foreground rounded-xl">
              {authorName
                .split(" ")
                .map((n) => n[0])
                .join("")}
            </AvatarFallback>
          </Avatar>

          <div className="flex flex-col items-center gap-1 md:flex-row md:gap-2">
            <span className="text-base font-medium text-white">{authorName}</span>
            <span className="hidden text-white opacity-50 md:inline-block">•</span>
            <span className="text-base text-white/80">{authorRole}</span>
          </div>

          {result && (
            <div className="mt-2 rounded-full bg-white/10 px-4 py-2">
              <span className="text-sm text-white/90">{result}</span>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
